import React from 'react';
import {ApiFetch} from './ApiFetch';

const MEMBERS_URL = require('./Urls').MEMBERS_URL;
const DISMISS_KEY = 'tm_app_migrate_dismissed';

/**
 * app -> members migration prompt (voluntary opt-in window).
 *
 * Minimal, functional styling only — the designer will restyle the banner
 * and modal afterward. Behaviour is the part that matters: "Switch" POSTs
 * /user/switch-to-members/ (sets use_app=False + iq_v2_migrated=True — no
 * data moves, app data already lives in the members UserChild tables) and
 * then sends the user to the members portal.
 */
class MigrateBanner extends React.Component {
    constructor(props) {
        super(props);
        let dismissed = false;
        try {
            dismissed = window.localStorage.getItem(DISMISS_KEY) === '1';
        } catch (e) {
            dismissed = false;
        }
        this.state = {dismissed: dismissed, modalOpen: false, switching: false, error: null};
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.dismiss = this.dismiss.bind(this);
        this.doSwitch = this.doSwitch.bind(this);
    }

    openModal() {
        this.setState({modalOpen: true, error: null});
    }

    closeModal() {
        this.setState({modalOpen: false});
    }

    dismiss() {
        try {
            window.localStorage.setItem(DISMISS_KEY, '1');
        } catch (e) {
            // ignore storage failures — banner just reappears next load
        }
        this.setState({dismissed: true});
    }

    doSwitch() {
        this.setState({switching: true, error: null});
        ApiFetch('user/switch-to-members/', 'POST', {})
            .then(() => {
                window.location.href = MEMBERS_URL;
            })
            .catch(() => {
                this.setState({
                    switching: false,
                    error: 'Something went wrong. Please try again.',
                });
            });
    }

    render() {
        const user = this.props.user;
        // Only app users see this, and only while they haven't dismissed it.
        if (!user || !user.use_app || this.state.dismissed) {
            return null;
        }

        const bannerStyle = {
            background: '#1f3763', color: '#fff', padding: '10px 16px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: '12px', fontSize: '14px', flexWrap: 'wrap',
        };
        const primaryBtn = {
            background: '#fff', color: '#1f3763', border: 'none',
            borderRadius: '4px', padding: '6px 14px', cursor: 'pointer',
            fontWeight: 'bold',
        };
        const linkBtn = {
            background: 'transparent', color: '#fff',
            border: '1px solid rgba(255,255,255,0.6)', borderRadius: '4px',
            padding: '6px 12px', cursor: 'pointer',
        };

        return (
            <div>
                <div style={bannerStyle}>
                    <span>We&rsquo;ve moved! Switch to the new TestingMom experience &mdash; same account, same progress.</span>
                    <button style={primaryBtn} onClick={this.openModal}>Switch now</button>
                    <button style={linkBtn} onClick={this.dismiss}>Not now</button>
                </div>

                {this.state.modalOpen &&
                    <div style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                        background: 'rgba(0,0,0,0.5)', display: 'flex',
                        alignItems: 'center', justifyContent: 'center', zIndex: 10000,
                    }} role="dialog" aria-modal="true">
                        <div style={{
                            background: '#fff', color: '#222', borderRadius: '8px',
                            padding: '28px', maxWidth: '440px', width: '90%',
                            textAlign: 'center',
                        }}>
                            <h2 style={{marginTop: 0}}>Switch to the new experience</h2>
                            <p>
                                Your children, tests, and progress come with you &mdash;
                                nothing is lost. You&rsquo;ll be taken to the new site now.
                            </p>
                            {this.state.error &&
                                <p style={{color: '#b00020'}}>{this.state.error}</p>}
                            <div style={{
                                display: 'flex', gap: '10px', justifyContent: 'center',
                                marginTop: '18px',
                            }}>
                                <button
                                    style={{...primaryBtn, background: '#1f3763', color: '#fff'}}
                                    onClick={this.doSwitch}
                                    disabled={this.state.switching}
                                >
                                    {this.state.switching ? 'Switching…' : 'Take me there'}
                                </button>
                                <button
                                    style={{...linkBtn, color: '#1f3763', borderColor: '#1f3763'}}
                                    onClick={this.closeModal}
                                    disabled={this.state.switching}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default MigrateBanner;
